export default {
  validations: {
    numeric: 'Можна вводити лише цифри',
    password:'Неприпустимі символи, використовуйте “AZ, 0-9, @%!?',
    passport_numeric: 'Перевірте правильність',
    pw_confirm: 'Паролі не збігаються',
    required: 'Це поле обов\'язкове',
    min: 'Мінімальна кількість символів: {length}',
    max: 'Максимальна кількість символів: {length}',
    length: 'Кількість символів повинна бути рівна {length}',
    email: 'Перевірте правильність введення вашої електронної пошти',
    reg_email: 'Перевірте правильність введення вашої електронної пошти. Використовуйте лише букви латинської абетки, цифри, крапку або спеціальни символи: @_-',
    ua_letters_space_hyphen: 'Можна використовувати лише літери української абетки, пробіли та тире',
    neres_letters_space_hyphen: 'Можна використовувати лише літери латинської абетки, пробіли та тире',
    ua_birth_place: 'Можна використовувати лише літери української абетки, пробіли, крапки, коми та тире',
    neres_birth_place: 'Можна використовувати лише літери латинської абетки, пробіли, крапки, коми та тире',
    ua_letters_space: 'Можна використовувати лише літери української абетки та пробіли',
    bank_name: 'Перевірте правильність назви банку',
    identify_code: 'Перевірте правильність введення номеру вашого ідентифікаційного коду',
    ua_letters_space_numeric: 'Можна вводити тільки цифри і букви українського алфавіту: малі та великі, пробіли, крапка',
    ua_letters_space_numeric_dash: 'Можна вводити тільки цифри і букви українського алфавіту: малі та великі, пробіли, крапка, дефис, тире',
    neres_letters_space_numeric: 'Можна вводити тільки цифри і букви латинського алфавіту: малі та великі, пробіли, крапка',
    neres_letters_space_numeric_dash: 'Можна вводити тільки цифри і букви латинського алфавіту: малі та великі, пробіли, крапка, дефис, тире',
    street_name: 'Можна використовувати лише літери української абетки, цифри, пробіли та спеціальні символи ,./-',
    neres_street_name: 'Можна використовувати лише літери латинської абетки, цифри, пробіли та спеціальні символи ,./-',
    ua_house: 'Можна використовувати лише літери української абетки, цифри, пробіли та спеціальні символи ./-',
    neres_house: 'Можна використовувати лише літери латинської абетки, цифри, пробіли та спеціальні символи ./-',
    ua_flat_number: 'Можна використовувати лише цифри, літери української абетки, спеціальні символи /.-',
    neres_flat_number: 'Можна використовувати лише цифри, літери латинської абетки, спеціальні символи /.-',
    iban: 'Перевірте правильність введеного IBAN',
    ua_passport_series: 'Серія паспорта повинна містити латинські та українськi літери',
    ua_passport_series_latin: 'Серія паспорта повинна містити латинські літери',
    ua_passport_series_latin_number: 'Серія паспорта повинна містити латинські літери або цифри',
    eddr_number: 'Перевірте правильність введення номера запису в Єдиному державному демографічному реєстрі',
    ua_card_expire: 'Перевірте правильність строку дії карти',
    ua_valid_until: 'Перевірте правильність дати закінчення документа',
    register_source: 'Можна використовувати лише літери латинської та української абетки, цифри, пробіли, коми, точки та тире',
    neres_letters_space_dash: 'Можна використовувати лише літери латинської абетки, пробіли та тире',
    neres_identify_code: 'Перевірте правильність введення номеру вашого ідентифікаційного коду. Можна використовувати лише цифри, літери латинської абетки, цифри, пробіли, крапки та тире',
    neres_state_region: 'Можна використовувати лише літери латинської абетки, спеціальні символи -',
    ua_state_region: 'Можна використовувати лише літери української абетки, спеціальні символи -',
    ua_registration_address: 'Можна використовувати лише літери української абетки, спеціальні символи .,/-',
    neres_registration_address: 'Можна використовувати лише літери латинської абетки, спеціальні символи .,/-',
    neres_iban: 'Перевірте правильність введеного IBAN',
    neres_bank_name: 'Перевірте правильність назви банку',
    full_age: 'Реєстрація неможлива для клієнтів молодше 18 років',
    card_is_not_unique: 'Номер картки має бути унікальним',
    iban_is_not_unique: 'Номер рахунку IBAN має бути унікальним',
    neres_index: 'Можна використовувати лише літери латинської абетки, пробіли та тире',
    phone: 'Перевірте правильність введення контактного номера телефону',
    ua_address: 'Можна використовувати літери української абетки, спеціальні символи .,/-',
    'date-range-is-not-correct': 'Початкова дата періоду не має перевищувати кінцеву',
    'not_past_date': 'Дата генерації звіту не може бути пізніше вчорашнього дня'
  },
  'backend-errors': {
    'account-is-payout': 'Цей рахунок не можна видалити, оскільки він є основним для валютних виплат. Видалення стане можливим після заміни його на інший основний рахунок.'
  },
  common: {
    'year': 'Рік',
    'yes': 'Так',
    'no': 'Ні',
    'email': 'Електронна пошта',
    'password': 'Пароль',
    'wrong-code': 'Невірний код',
    'code-not-found': 'Строк дії коду сплив, будь ласка, запитайте новий код',
    'code-expired': 'Строк дії коду сплив, будь ласка, запитайте новий код',
    'waiting-documents-from-server': 'Триває обробка підпису',
    'time-of-waiting-documents-from-server': 'Після завершення обробки (близько 15 хвилин), підписані документи з’являться у цьому кабінеті.',
    'if-you-have-problems': 'Якщо у вас виникли якісь труднощі або запитання, зверніться в підтримку через e-mail:',
    'waiting-for-diia-documents': 'Генеруються документи на підпис',
    'time-of-waiting-diia-documents-from-server': 'Документи будуть згенеровані протягом 1-2  хвилин, після цього ви будете автоматично переадресовані на їх підписання',
    'if-you-have-problems-with-phone': 'Якщо у вас виникли якісь труднощі або запитання, зверніться в підтримку через e-mail:',
    'if-you-have-questions': 'Якщо у вас виникли питання або труднощі під час онлайн реєстрації зв\'яжіться з нами за електронною поштою',
    'add-photo-scan-copy': 'Додати фото/скан-копію',
    'drag-document-or-attach': 'Перетягніть документ у поле або прикріпіть за допомогою кнопки Завантажити',
    'drag-document-file-extensions': 'Завантажте зображення в одному з графічних форматів: jpg, jpeg, png, bmp',
    'please-make-sure-photo': 'Будь ласка, переконайтеся, що документ на фото/скані, що завантажується, відображено повністю, відсутні відблиски або інші елементи, що закривають текст документа',
    'uploaded-percent': 'Завантажено {number}%',
    'upload-failed': 'Не завантажено',
    'upload-successful': 'Завантажено',
    'unacceptable-file-format': 'Файли цього формату не можна завантажувати, завантажте зображення в одному з графічних форматів. Наприклад, pdf, jpg, jpeg, png і так далі',
    'unacceptable-file-format-nonresident': 'Файли цього формату не можна завантажувати, завантажте зображення в одному з графічних форматів. Наприклад, jpg, jpeg, png і так далі',
    'file-too-large': 'Неприпустимо великий розмір файлу',
    'logout-confirm-text': 'Ви впевнені, що хочете вийти з особистого кабінету?',
    'logout-confirm': 'Вийти',
    'logout-decline': 'Залишитися',
    'wrong-login-or-password': 'Логін або пароль були введені невірно, будь ласка перевірте'
  },
  notifications: {
    'something-went-wrong': 'Щось пішло не так',
    'something-went-wrong-recheck': 'Щось пішло не так. Перевірте правильність посилання',
    'something-went-wrong-recheck-phone': 'Перевірте правильність введення контактного номера телефону',
    'next-try-will-be-available': 'Наступна спроба буде доступна через {minutes}:{seconds} хвилин',
    'application-is-not-sent': 'На жаль, анкета не була успішно відправлена на перевірку. Будь ласка, спробуйте знову',
    'register-email-forbidden': 'Регістрація з домену пошти {email} недоступна',
    'delete-photo-message': 'Ви впевнені що бажаете видалити це зображення?',
    'delete-photo-yes': 'Так',
    'delete-photo-no': 'Ні',
    'not-found': 'Не знайдено',
    'reset-password-wrong-token-text': 'Ви вже використали це посилання для відновлення пароля раніше.',
    'get-link-to-update-password-button-text':'Отримати посилання для відновлення пароля знову',
    'return-to-login-button-text': 'Я пам\'ятаю свій пароль і хочу увійти',
    'citizen-modal-title':'На жаль тимчасово немає технічної<br/>можливості онлайн реєстрації<br/>для осіб без громадянства.',
    'citizen-modal-text': 'Подати заявку на реєстрацію особам без громадянства можливо за контактами:',
    'residency-modal-title':'На жаль тимчасово немає технічної<br/>можливості онлайн реєстрації<br/>для резидентів деяких країн.',
    'residency-modal-text': 'Подати заявку на реєстрацію для резидентів деяких країн можливо за контактами:',
    'non-resident-modal': 'Шановний клієнте, віддалена онлайн реєстрація нерезидентів наразі відсутня',
    'non-resident-text': 'Надійшліть, будь ласка, ваш запит і ми обов’язково повідомимо про початок реєстрації, коли це стане можливо:',
    'sms-code-send-fail-text': 'Якщо ви не отримали СМС-код, зверніться у підтримку через e-mail:',
    'sms-code-send-fail-text-with-phone': 'Якщо ви не отримали СМС-код, зверніться у підтримку через e-mail:',
    'code-send-fail-text': 'Якщо ви не отримали код, зверніться у підтримку через e-mail:',
    'code-send-fail-text-with-phone': 'Якщо ви не отримали код, зверніться у підтримку через e-mail:'
  },
  'password-hints': {
    'characters-count': '8-20 символів',
    'arabic-numbers': 'Aрабські цифри 0-9',
    'latin-alphabet': 'Латинський алфавіт A-Z',
    'special-characters': 'Спец символи @%!?'
  },
  'verification-modal': {
    'phone-need-verification-title': 'Ваш номер телефону <br/>{phone}<br/>не верифіковано',
    'go-to-verification': 'Перейти до підтвердження телефонного номера',
    'phone-verification-text': 'Якщо ви бажаєте змінити номер телефону, напишіть звернення з вашої верифікованої електронної адреси у підтримку через e-mail:',
    'otp-was-sent': 'Вам був надісланий OTP код.<br/>Введіть його для підтвердження операції',
    'resend-code': 'Надіслати код повторно',
    'confirm': 'Підтвердіть',
    'code-was-sent-to-phone': 'На номер<br/>{phone} <br> було надіслано код',
    'code-was-sent-to-email': 'На пошту <br> {email} <br> було надіслано код',
    'code-was-sent-to': 'Код було відправлено на {contact}<br/>Введіть його для підтвердження операції',
    'sign-documents': 'Підписати документи',
    'time-left':'Термін дії коду закінчується через',
    'time-left-short':'Строк дії коду:',
    'tries-left':'Кількість спроб, що залишилася:',
    'tries-left-short':'Залишилося спроб:'
  },
  'login-page': {
    'get-change-password-link': 'Отримайте посилання для зміни пароля',
    'link-was-sent': 'На вашу електронну пошту {email} було надіслано листа з посиланням. Скористайтеся ним, щоб змінити пароль.',
    'forgot-password': 'Забули пароль?',
    'log-in': 'Увійти',
    'email-hint': 'Електронна пошта, вказана при реєстрації в ICU Trade або при купівлі у застосунку Дія.',
    'password-hint': 'Пароль той самий, що був створений при заповненні анкети на реєстрацію.<br/><br/>У разі, якщо пароль невірний або перша купівля ОВДП пройшла через застосунок Дія, скористайтесь кнопкою «Забули пароль?» для створення нового. Пароль на вхід до торговельної системи та особистого кабінету можуть бути різними.',
  },
  'change-password': {
    'enter-your-email': 'Введiть вашу пошту, ми надiшлемо на неї посилання для безпечного входу',
    'change-password': 'Змінити пароль',
    'successful-change': 'Пароль успішно змінено.',
    'go-back-to-cabinet': 'Повернутися до особистого кабiнету',
    'enter-and-confirm-password': 'Будь ласка, введiть i повторiть новий пароль',
    'enter-new-password': 'Оберiть новий пароль',
    're-enter-password': 'Підтвердіть пароль'
  },
  'register': {
    'title': 'Реєстрація клієнта ICU',
    'resident-title': 'Реєстрація для резидентів України',
    'contact-phone': 'Контактний телефон',
    'email': 'Електронна пошта',
    'password-creation-hint': 'Створення пароля в особистому кабінеті захистить ваші особисті дані',
    'enter-password': 'Оберiть пароль',
    're-enter-password': 'Пiдтвердiть пароль',
    'register': 'Зареєструватися',
    'registration': 'Реєстрація',
    'how-did-you-find-out': 'Звідки ви дізналися про нас?',
    'your-option': 'Ваш варіант',
    'social-networks-option': 'Соцмережі (Facebook, Twitter, LinkedIn, Telegram)',
    'social-media-option': 'ЗМІ',
    'from-friend-option': 'Від друзів/колег/рідних',
    'your-option-option': 'Ваш варіант',
    'phone-hint': 'Введіть контактний номер, який надалі плануєте використовувати для входу в систему',
    'email-hint': 'Введіть електронну пошту, яку надалі плануєте використовувати для входу в систему',
    'already-requested': 'Ваше звернення вже було отримано. Менеджер зв\'яжеться з вами.',
    'diya-registration-btn-text': 'Верифікація через Дію',
    'diya-registration-btn-hint': 'Через Дія.Шерінг - автоматичне заповнення анкети та швидка передача документів',
    'bankid-registration-btn-text': 'Верифікація через BankID НБУ',
    'bankid-registration-btn-hint': 'Через BankID НБУ - ручне заповнення анкети та завантаження документів'
  },
  'qr-code': {
    'scan-qr': 'Зчитайте QR-код сканером у застосунку Дiя',
    'scan-qr-subtext': 'Дотримуйтесь інструкцій у застосунку Дія, щоб успішно закінчити реєстрацію',
    'scan-qr-diia-subtext': 'Дотримуйтесь інструкцій у застосунку Дія, щоб успішно підписати документи з допомогою Дія.Підпису',
    'scan-qr-block-text': 'Продовжити через 00:{sec}',
    'proceed': 'Продовжити',
    'scan-qr-error': 'Для продовження відскануйте QR-код',
    'scan-qr-mobile-error': 'Будь ласка, натисніть на QR-код для переходу в застосунок Дія',
    'update-qr':'Отримати новий QR-код',
    'back-to-site': 'Повернутися на сайт',
    'qr-error': 'Щось пішло не так. Будь ласка, повторіть ще раз',
    'qr-expired': 'Строк дії QR-коду сплив. Будь ласка, отримайте новий код',
    'qr-proceed-to-finish': 'Будь ласка, завершіть процедуру у застосунку Дiя',
    'try-again': 'Повторити спробу',
    'get-new-qr': 'Отримати новий QR-код',
    'account-opening-process': 'Йде процес відкриття вашого рахунку. Це може зайняти деякий час. Очікуйте наступні повідомлення на вашу електронну адресу. Дякуємо за розуміння!',
    'process-success':'Процес реєстрації завершено. Вам надано доступ до торговельної системи. Посилання для доступу було надіслано на вашу електронну адресу.',
    'go-to-cabinet': 'Перейти до торгового кабінету',
    'no-full-data-text': 'На жаль, документів, переданих сервісом Дія, недостатньо для проходження реєстрації',
    'no-full-data-hint': 'Будь ласка, перевірте наявність ідентифікаційного коду та документу, що засвідчує особу, у вашому застостунку Дія та спробуйте ще раз. Якщо помилка повторюється, заповніть анкету вручну через BankID НБУ',
    'try-diya': 'Спробувати ще раз через Дія.Шеринг',
    'register-bank-id': 'Зареєструватись вручну через BankID НБУ',
    'error-text': 'На жаль, під час автоматичної передачі даних сталася помилка',
    'error-hint': 'Будь ласка, спробуйте ще раз або заповніть анкету вручну через BankID НБУ',
    'not-unique-data': 'Отримані дані вже використовуються іншим користувачем у системі. Для продовження реєстрації введіть унікальні дані. Якщо ви не реєструвалися раніше, натисніть на кнопку "Зв\'язатися з менеджером" і ми сконтактуємо з вами.',
    'call-manager': 'Зв\'язатися з менеджером',
    'waiting': 'Очікуємо відповідь від сервера',
    'contacts': 'Якщо у вас виникли труднощі або запитання, зверніться у підтримку через e-mail:',
    'cancel-registration': 'Перервати',
    'continue-registration': 'Продовжити реєстрацію',
    'continue-diia-sign': 'Продовжити підписання',
    'cancel-diia-sign': 'Перервати',
    'cancel-registration-request': 'Ви збираєтеся перервати реєстрацію через Дія?',
    'cancel-diia-sign-request': 'Скасувати підписання документів за допомогою Дія.Підпис?',
    'scan-qr-mobile-subtext1': 'Натисніть на QR код, щоб перейти до застосунку Дія.',
    'scan-qr-mobile-subtext2': 'Дотримуйтесь інструкцій у застосунку Дія, щоб успішно закінчити реєстрацію.',
    'scan-qr-mobile-diia-sign-subtext2': 'Дотримуйтесь інструкцій у застосунку Дія, щоб успішно підписати документи за допомогою Дія.Підпису.',
    'scan-qr-mobile-success1': 'Копії документів успішно передано!',
    'scan-qr-doc-sign-success': 'Підписання документів успішно завершено!<br/><br/>Наразі вам вже надано доступ до особистого кабінету клієнта. Логін та пароль ті самі, що були вами вказані на початку реєстраціі. Найближчим часом після  обробки документів вам буде надано доступ і до торговельної системи ICU Trade. Посилання на створення паролю до ICU Trade буде надіслано на вашу електронну адресу.',
    'scan-qr-mobile-doc-sign-success1': 'Документи успішно підписані!',
    'scan-qr-mobile-success2': 'Будь ласка, поверніться на вкладку або пристрій, де ви розпочинали реєстрацію, та натисніть там кнопку "Продовжити"',
    'scan-qr-mobile-doc-sign-success2': 'Будь ласка, поверніться на сторінку сайту, з якої ви перейшли для підписання, та натисніть кнопку "Продовжити"',
    'scan-qr-doc-sign-success-to-cabinet': 'Перейти до особистого кабінету клієнта',
    'choose-register-source': 'Оберіть варіант віддаленої верифікації',
    'confirm-data': 'Підтверджую дані / Відправити анкету'

  },
  'duplicate-check': {
    'phone-or-email-is-used': 'Вказаний номер телефону або адреса електронної пошти вже використовується. Для реєстрації змініть данні. Якщо ви не реєструвалися, натисніть на кнопку "Зв\'язатися з менеджером" і наш менеджер з вами зв\'яжеться',
    'contact-the-manager': 'Зв\'язатися з менеджером',
    'manager-has-been-notified': 'Менеджер отримав повiдомлення та зв’яжеться з вами найближним часом',
  },
  'register-final-page': {
    'thanks-for-application': 'Дякуємо за вашу заявку!',
    'application-was-sent': 'Вашу Анкету було надіслано на перевірку до ICU <br><br> Найближчим часом очікуйте повідомлення на Вашу електронну адресу з подальшими інструкціями щодо підписання Договору.',
    'back-to-site': 'Повернутися на сайт',
    'to-cabinet': 'Перейти до особистого кабінету'
  },
  'application-form': {
    'modal': {
      'header':'Вимоги щодо заповнення полів анкети для {resident_status} України',
      'text':'Текстові поля онлайн-анкети потрібно заповнювати {lang} мовою.',
      'button':'Підтвердити',
      'resident': 'резидентів',
      'nonresident': 'нерезидентів',
      'lang': {
        'ua': 'українською',
        'en': 'англійскою'
      }
    },
    'continue': 'Продовжити',
    'i-confirm': 'Підтверджую власноручне заповнення та підпис анкети',
    'add-another-account': 'Додати інший рахунок',
    'press-to-send': 'Натисніть щоб надіслати анкету на перевірку',
    'step-0':{
      'title': 'Реєстрація клієнта ICU',
      'register': 'Зарееструватися',
      'employees': 'Виберіть тип зайнятості',
      'proceeds': 'Виберіть розмір доходу на місяць',
      'no-citizenship': 'Особа без громадянства',
      'citizenship': 'Введіть країну вашого громадянства',
      'residency': 'Резидентом якої країни ви є?'
    },
    'step-1': {
      'title': 'Крок 1 iз 5: ПІБ, контактні дані, місце народження та ІПН',
      'phone': 'Контактний телефон',
      'email': 'Електронна пошта',
      'last-name': 'Прізвище',
      'last-name-nonresident': 'Введіть Ваше прізвище латинськими літерами згідно ідентифікаційного документа',
      'last-name-hint-uk': 'Введіть ваше прізвище українською',
      'last-name-hint-en': 'Введіть ваше прізвище латиницею',
      'first-name': 'Ім’я',
      'first-name-nonresident': 'Введіть Ваше імʼя латинськими літерами згідно ідентифікаційного документа',
      'first-name-hint-uk': 'Введіть ваше повне ім\'я українською',
      'first-name-hint-en': 'Введіть ваше повне ім\'я латиницею',
      'middle-name': 'По-батькові',
      'middle-name-nonresident': 'Введіть Ваше по-батькові латинськими літерами згідно ідентифікаційного документа',
      'middle-name-hint-uk': 'Введіть по-батькові українською',
      'middle-name-hint-en': 'Введіть по-батькові латиницею',
      'date-of-birth': 'Дата народження',
      'date-of-birth-hint': 'Введіть повну дату народження',
      'country-of-birth': 'Країна народження',
      'country-of-birth-hint': 'Введіть назву країни',
      'place-of-birth': 'Мicце народження',
      'place-of-birth-hint': 'Введіть країну та назву міста народження',
      'citizenship': 'Громадянство',
      'citizenship-hint': 'Введіть країну вашого громадянства',
      'residency': 'Резидентство',
      'tax-residency': 'Податкове резидентство',
      'has-inn': 'У мене є ІПН України',
      'tax-id-number': 'Ідентифікаційний код України',
      'tax-id-number-short': 'Ідентифікаційний код',
      'photo-tax-id-number': 'Фото/скан ідентифікаційного коду',
      'your-country-has-inn': 'У мене є ІПН моєї країни',
      'your-country-tax-id-number': 'Ідентифікаційний код вашої країни',
      'foreign-has-inn': 'У мене є ІПН iноземної країни',
      'foreign-tax-id-number': 'Ідентифікаційний код iноземної країни',
      'tax-id-number-hint': 'Введіть номер вашого ідентифікаційного коду',
      'photo-scan-tax-id': 'Завантажити копію оригіналу ІПН<br/>(скрін екрана із додатка ДіЯ не приймається)',
      'photo-scan-without-ipn': 'Додати фото/скан сторінки в паспорті без ІПН та довідки про відсутність',
      'last-name-neres': 'Прізвище',
      'last-name-hint-neres': 'Введіть ваше прізвище',
      'first-name-neres': 'Ім’я',
      'first-name-hint-neres': 'Введіть ваше повне ім\'я',
      'middle-name-neres': 'По-батькові',
      'middle-name-hint-neres': 'Введіть по-батькові',
    },

    'step-2': {
      'title': 'Крок 2 iз 5: Відомості про документ, що посвідчує особу',
      'id-document-subtitle': 'Документ, що посвідчує особу',
      'document-type': 'Вид документу',
      'document-type-hint': 'Оберiть тип документу',
      'country':'Країна',
      'my-passport-is-biometric': 'Мій закордонний паспорт біометричний',
      'reestr-number-id-card': 'Унікальний номер запису в Єдиному державному демографічному реєстрі ("Запис №" на ID-карті)',
      'reestr-number': 'Унікальний номер запису в Єдиному державному демографічному реєстрі',
      'reestr-number-hint': 'Введіть номер запису в Єдиному державному демографічному реєстрі',
      'reestr-number-foreign-hint': 'Введіть номер запису в Єдиному державному демографічному реєстрі з вашого закордонного паспорта - це поле "Запис №"',
      'series': 'Серія',
      'series-hint': 'Введіть серію паспорта латинськими або українськими літерами',
      'series-international-hint': 'Введіть серію паспорта латинськими літерами',
      'series-international-number-hint': 'Введіть серію паспорта латинськими літерами або цифрами',
      'passport-id-number': 'Номер',
      'id-number': 'Номер',
      'id-card-number': 'Номер',
      'passport-id-number-hint': 'Введіть номер документу',
      'date-of-issue': 'Дата видачі',
      'date-of-issue-hint': 'Введіть дату видачі документа',
      'date-of-expiry': 'Діє до',
      'date-of-expiry-hint': 'Введіть дату закінчення документа',
      'issuing-authority-text-hint': 'Введіть назву органа, який видав документ, що засвідчує особу, так, як написано на документі',
      'issuing-authority-code-hint': 'Введіть код органу, який видав документ, що засвідчує особу як написано на документі',
      'issuing-authority': 'Орган, що видав',
      'issuing-authority-code': 'Код уповноваженого суб\'єкта, що видав документ',
      'photo-passport-label':'Фото/скан всіх розворотів паспорта з відмітками (необхідно прикріпити фото або скани розворотів 0-1,2-3,4-5,6-7,10-11,12-13)',
      'photo-passport-label-non-citizen':'Фото/скан всіх сторінок паспорту з відмітками',
      'photo-passport-hint':'Необхідно прикріпити фото або скани всіх розворотів паспорта з відмітками (необхідно прикріпити фото або скани розворотів 0-1,2-3,4-5,6-7,10-11,12-13). Перетягніть документ у поле або прикріпіть за допомогою кнопки завантаження',
      'photo-foreign-passport-hint':'Необхідно прикріпити фото або скан документа.',
      'photo-id-label': 'Фото/скан-копія 2-х сторін ID-картки',
      'photo-id-hint': 'Додайте скан або фото обох сторін карти.',
      'photo-foreign-id-label': 'Photo / scan copy of the two sides of the ID-card',
      'photo-foreign-id-hint': 'Необхідно прикріпити фото або скан документа.',
      'photo-int-passport-label': '1-а сторінка закордонного паспорта',
      'photo-int-passport-hint': 'Необхідно прикріпити фото або скан першої сторінки закордонного паспорта.',
      'photo-doc-label': 'Фото/скан всіх сторінок документа з відмітками',
      'photo-doc-short': 'Фото/скан всіх сторінок документу',
      'photo-doc-hint': 'Необхідно прикріпити фото або скан документа.',
      'photo-doc-nonresident': 'Завантажте фото/скан ідентифікаційного документа (якщо він містить англомовний переклад) або закордонного паспорта',
      'certificate-of-residence': 'Витяг про місце проживання (фото з оригіналу або файл із додатку Дія)',
      'certificate-of-residence-hint': 'Необхідно завантажити «Витяг про місце проживання (фото з оригіналу або файл  із додатку Дія)».<br><br> Перетягніть документ у поле або прикріпіть за допомогою кнопки завантаження',
      'second-photo': 'Друга вклеєна фотографія',
      'second-photo-hint': 'Вам понад 45 років, прикладіть додатковий скан другої вклеєної фотографії',
      'photo-selfie-label': 'Селфі з документом, що посвідчує особу',
      'photo-selfie-label-nonresident': 'Завантажте селфі з ідентифікаційним документом з попереднього кроку. На фото має бути чітко видно ваше обличчя та текст на документі',
      'photo-selfie-hint': 'Зробіть селфі з вашим ідентифікаційним документом. Документ має бути повністю та чітко видно в кадрі. Перетягніть файл у поле або прикріпіть за допомогою кнопки завантаження',
    },

    'step-3': {
      'title': 'Крок 3 iз 5: Адреса реєстрації та фактичного проживання',
      'address-subtitle': 'Адреса реєстрації',
      'registration-address': 'Адреса реєстрації',
      'address-placeholder': '01054, Україна, м. Київ, вул. Богдана Хмельницького 19-21',
      'address-hint': 'Введіть повну адресу як на прикладі: 01054, Україна, м. Київ, вул. Богдана Хмельницького 19-21',
      'living-address': 'Адрес фактичного проживання',
      'country': 'Країна',
      'country-hint': 'Виберіть країну',
      'region': 'Область',
      'region-hint-uk': 'Введіть назву області українською мовою',
      'region-hint-en': 'Введіть назву області латиницею',
      'settlement-type': 'Тип населенного пункту',
      'settlement-type-hint': 'Виберіть тип населенного пункту',
      'settlement': 'Населений пункт',
      'settlement-hint-uk': 'Введіть назву населенного пункту українською мовою',
      'settlement-hint-en': 'Введіть назву населенного пункту латиницею',
      'street-type': 'Тип вулицi',
      'street-type-hint': 'Виберіть тип вулиці',
      'street': 'Вулиця',
      'street-hint-uk': 'Введіть назву вулиці українською мовою',
      'street-hint-en': 'Введіть назву вулиці латиницею',
      'house': 'Будинок',
      'house-hint': 'Введіть номер будинку',
      'flat': 'Номер квартири',
      'flat-hint': 'Введіть номер квартири',
      'index': 'Індекс',
      'index-hint': 'Введіть iндекс',
      'registration-is-living-subtitle': 'Адрес фактичного проживання',
      'registration-is-living': 'Адрес фактичного проживання співпадає з адресою реєстрації',
      'is-internal-migrant': 'Я переселенець із території Криму чи території ОРДЛО',
      'migrant-certificate': 'Довідка тимчасово переміщеної особи',
      'migrant-certificate-hint': 'Будь ласка, прикріпіть довідку ТПО (тимчасово переміщеної особи), якщо ви переїхали з території Криму чи ОРДЛО',
      'state-or-region': 'Штат / область',
      'state-or-region-hint-uk': 'Введіть назву штату українською мовою',
      'state-or-region-hint-en': 'Введіть назву штату латиницею',
      'actual-address': 'Адрес фактичного проживання',
      'actual-address-hint': 'Введіть адресу реєстрації: населений пункт, вулицю, будинок та номер квартири',
      'photo-scan-certificate': 'Фото/скан довідки про місце проживання'
    },

    'step-4': {
      'title': 'Крок 4 із 6: Реквізити банківських рахунків та карток клієнта для виведення коштів',
      'data-warning': 'Уважно перевірте коректність заповнення полів, у разі помилково внесених даних, вивести кошти на вказані реквізити буде неможливо!',
      'another-account': 'Інший рахунок',
      'iban': 'IBAN або Номер рахунку клієнта',
      'iban-hint': 'Можна вводити лише цифри та символи латинської абетки',
      'swift': 'SWIFT або BIC code',
      'number': 'Номер рахунку',
      'name': 'Назва рахунку',
      'additional_information': 'Додаткові реквізити та реквізити банків кореспондентів (назва, SWIFT, BIC) - можуть бути вписані в один рядок',
      'bank': 'Назва банку, в якому відкрито рахунок',
      'bank-hint': 'Введіть назви банку українською або латинською',
      'card_number': 'Номер картки до цього IBAN рахунку',
      'card_number-hint': 'Введіть номер вашої банківської картки до цього IBAN рахунку',
      'card_expire': 'Діє до',
      'card_expire-hint': 'Введіть дату закінчення документа',
      'currency': 'Валюта рахунку',
      'currency-nonresident': 'Валюта рахунку',
      'currency-hint': 'Виберіть валюту рахунку',
      'doc': 'Вкладення (фото, скріншот, сканкопія довідки) має підтверджувати, що вказаний IBAN/номер рахунку належить саме Вам та містити всі додаткові реквізити банків кореспондентів (назву, SWIFT, BIC), у разі наявності',
      'doc-hint': 'Довідка від вашого банку з реквізитами рахунку у форматі IBAN/Номер рахунку клієнта або скріншот реквізитів з додатку вашого банку',
      'add-card-1': 'Додати{more} картку до цього',
      'add-card-2': 'IBAN рахунку'
    },

    'step-5': {
      'title': 'Крок 4 iз 5: Інформація для цілей FATCA',
      'is_usa_citizen': 'Чи є Ви громадянином Сполучених Штатів Америки?',
      'has_residence': 'Чи є у Вас право на постійне проживання в США (green card, тощо)?',
      'is_usa_born': 'Чи є Вашим місцем народження територія США?',
      'has_usa_address': 'Чи є у Вас адреса проживання або поштова адреса в США, в т.ч. адреса до запитання (hold mail) чи довірча\\управлінська адреса (in-care-of)?',
      'has_usa_phone': 'Чи є у Вас телефонний номер, зареєстрований у США?',
      'has_usa_payment_order': 'Чи є у Вас довгострокове платіжне доручення на перерахування коштів на рахунок (-и) в США (з метою інвестування та\\або накопичення)?',
      'has_usa_p_a': 'Чи надавалася Вами довіреність чи право підпису особі, яка має адресу в США?',
      'tin_code': 'Введіть TIN-код',
      'tin_code-hint': 'Введіть Індивідуальний ідентифікаційний номер платника податків (ITIN)',
    },

    'step-6': {
      'title': 'Крок 5 iз 5: Мета та характер встановлення ділових відносин',
      'target': 'Мета встановлення ділових відносин',
      'target-hint': 'Виберіть хоча б один із варіантів',
      'frequency': 'Характер ділових відносин',
      'frequency-hint': 'Виберіть один із варіантів',
      'date': 'Дата',
    },
  },
  'form-status': {
    'clarify-title': 'Необхідно уточнити дані',
    'clarify-text':'Для найшвидшого уточнення даних  сконтактуйте з нами через e-mail:',
    'clarify-text2':'або дочекайтесь поки ми зв\'яжемось з вами',
    'denied-title':'На жаль, реєстрація вашої анкети була відхилена',
    'denied-text':'Інформацію щодо причини відхилення ви можете отримати через e-mail:',
    'denied-button-text': 'Повернутися на сайт',
    'ready-title':'Ваші документи готові до підпису',
    'ready-text':'Наступним кроком підпишіть, будь ласка,  документи. Вам будуть надані дані з доступом до особистого кабінету клієнта, а після обробки документів у ICU, і дані доступу до торговельної системи ICU Trade. Зверніть увагу, що це може зайняти деякий час',
    'ready-button-text':'Перейти до підпису документів',
  },
  'document-sign': {
    'title':'Підпис документів',
    'text': 'Натискаючи кнопку "Підписати документи" ви підтверджуєте їх достовірність та надаєте згоду на використання ваших персональних даних для відкриття рахунку в ICU',
    'button-text':'Підписати документи',
    'download': 'Завантажити',
    'if-find-errors': 'Якщо ви знайшли будь-які помилки в документах, зверніться в підтримку через e-mail:',
    'contact-support': 'Якщо у вас виникли запитання або труднощі зв\'яжіться з нами через e-mail: ',
    'contact-support-with-phone': 'Якщо у вас виникли запитання або труднощі зв\'яжіться з нами через e-mail: ',
    'sign-by-diia': 'Підписати документи за допомогою Дія.Підпису',
    'success': {
      'title': 'Дякуємо! Документи успішно підписані',
      'text': 'Найближчим часом ви отримаєте посилання на реєстрацію в торговельній системі ICU Trade на ваш e-mail, де ви зможете придбати державні облігації та підтримати перемогу України.',
      'button': 'Перейти до особистого кабінету'
    },
    'error': {
      'title': 'Щось пішло не так, документи не підписано ((',
      'text': 'Спробуйте повернутися на один крок назад та підписати документи ще раз',
      'button': 'Повернутися'
    }
  },
  'signed-documents': {
    'page-title':'Підписані документи',
    'contact-support': 'Якщо ви виявили помилки в документах або у вас змінилися персональні дані, обовязково зверніться через e-mail для оновлення інформації:',
    'contact-support-with-phone': 'Якщо ви виявили помилки в документах або у вас змінилися персональні дані, обовязково зверніться через e-mail для оновлення інформації:'
  },
  'diya-check-data': {
    'title': 'Перевірте дані та заповніть порожні поля анкети для завершення реєстрації',
    'contacts-title': 'ПІБ, контактні дані, місце народження та ІПН',
    'document-title': 'Відомості про документ, що посвідчує особу',
    'address-title': 'Адреса реєстрації та фактичного проживання',
    'account-title': 'Реквізити банківських рахунків та карток клієнта для виведення коштів',
    'fatca-title': 'Інформація для цілей FATCA',
    'business-point-title': 'Мета та характер встановлення ділових відносин',
    'press-to-send': 'Натисніть щоб надіслати анкету на перевірку'
  },
  'server-error': {
    'header': 'Тимчасово недоступний. Планове обслуговування сервера.',
    'support-text':'Якщо у вас виникли будь-які питання, зверніться через<br /> e-mail:'
  },
  'pc': {
    'general': {
      'confirm-exit': 'Ви впевнені, що хочете вийти з особистого кабінету?',
      'exit': 'Вийти',
      'stay': 'Залишитися',
      'active': 'Активний',
      'in-process': 'В обробці',
      'save': 'Зберегти',
      'cancel': 'Відмінa'

    },
    'menu': {
      'my-profile': 'Мій профіль',
      'security': 'Анкета та безпека',
      'funds': 'Банківські рахунки',
      'document-request': 'Запит документів',
      'documents': 'Документи',
      'trade-limits': 'Торговельні ліміти',
      'messages': 'Повідомлення',
      'exit': 'Вихід'
    },
    'verification': {
      'title': 'Спосіб верифікації',
      'text':  'Виберіть спосіб отримання одноразового паролю',
      'verification-success-title': 'Дякую, ви верифікували ваш телефонний номер',
      'verification-success-message': 'Доступ до особистого кабінету<br/> відновлено',
      'return': 'Перейти'
    },
    'personal-data': {
      'title': 'Персональні дані',
      'show-all': 'Переглянути всі дані',
      'hide': 'Згорнути',
      'tooltip-text': 'Змінити дані може лише співробітник ICU. Будь ласка, надішліть запит на електронну адресу',
      'backoffice-status': 'Статус облікового запису',
      'employment': 'Тип зайнятості',
      'proceeds': 'Розмір доходу на місяць',
    },
    'password': {
      'title': 'Пароль',
      'enter-password': 'Введіть новий пароль',
      'confirm-password': 'Повторіть новий пароль ще раз',
      'change-password': 'Змінити пароль'
    },
    'messages': {
      'title': 'Cистемне повідомлення',
      'show-only-nonread':'Відображати лише непрочитані',
      'SYSTEM': 'Системні',
      'press-to-read': 'Натисніть, щоб прочитати повідомлення',
      'mark-as-read': 'Позначити як прочитані'
    },
    'trade-limits': {
      'last-update': 'Дані станом на',
      'note': '* данi по залишкам не враховують данi по торговим операцiям за поточний торговий день',
      'update': 'Оновити дані',
      'total-funds':'Сума всіх грошових коштів',
      'available-funds': 'Доступні грошові кошти',
      'blocked-funds': 'Сума заблокованих грошових коштів',
      'add-document': 'Додати документ на підтвердження походження ГК',
      'doc-archive': 'Архів документів на підтвердження ГК',
      'gk-confirm': 'Підтвердження ГК',
      'invest-limits': 'Ліміт інвестування*',
      'invest-limits-rest': 'Залишок ліміту для інвестування**',
      'note-1': '* Сума підтверджених коштів, доступних для інвестування',
      'note-2': '** Сума коштів, яку Клієнт може перерахувати Брокеру без необхідності підтвердження їх походження\n',
    },
    'accounts': {
      'title': 'Рахунки для валютних виплат',
      'fx-accounts-text': 'Валютні рахунки для виплат відсутні. Ви можете обрати відповідний рахунок зі списку нижче, натиснувши кнопку "Зробити основним рахунком для валютних виплат"',
      'account-delete-confirm': 'Ви впевнені, що хочете<br />видалити ',
      'current-account': 'цей рахунок',
      'current-card': 'цю картку',
      'account-delete': 'Так, видалити',
      'account-delete-cancel': 'Ні, не хочу видаляти',
      'choose-currency': 'Оберіть валюту, для якої цей рахунок буде основним для валютних виплат',
      'save-choose': 'Зберегти вибір',
      'accounts-tooltip-text': 'Банківські рахунки, що будуть використовуватися для виплат у валюті (долар, євро). Додаткові питання: ',
      'bank-cards': 'Верифіковані банківські рахунки та картки',
      'cards-tooltip-text': 'Банківські рахунки та картки, що можуть використовуватись для виведення коштів. Додаткові питання:',
      'usd': 'Долар',
      'eur': 'Євро',
      'uah': 'Гривня',
      'withdraw-make':'Зробити рахунком для валютних виплат',
      'add-account': 'Додати банківський рахунок/картку',
      'change-payout': 'Ви впевнені, що хочете змінити<br/>{currency} -рахунок для валютних виплат на <br/><span>{iban}</span>{card_number}',
      'account-has-no-card': '(Цей IBAN немає прив\'язаної карти)',
      'e-support-text': 'Важливо! <b>Картки еПідтримка не можуть бути використані, як карти для виплат</b>, крім виплат по ОВДП, що були куплені через застосунок ДІЯ.',
      'confirm-replace': 'Так, змінити рахунок для валютних виплат',
      'cancel-replace': 'Ні, не міняти',
      'additional-information': 'Додаткові реквізити',
      'card-manage': 'Управління картками',
      'verified-cards': 'верифіковані банківські картки',
      'card-confirm-image-label': 'Вкладення має підтверджувати, що обрана картка клієнта дійсно належить Вам',
      'card-confirm-image-hint': 'Вкладення (довідка/скріншот реквізитів з додатку вашого банку) мають підтверджувати, що обраний рахунок та/або картка клієнта дійсно належать Вам'
    },
    'documents': {
      'sign': 'Підписати',
      'download': 'Завантажити',
      'download-sign': 'Завантажити підпис ',
      'APPROVED': 'Схвалений',
      'REJECTED': 'Відхилений',
      'IN_PROCESS': 'В обробці',
      'PROCESSING': 'В обробці',
      'PROCESS': 'В обробці',
      'all': 'Всі',
      'mark_all_as_read': 'Позначити як прочитані',
      'request-archive': 'Архів запитів',
      'create-request': 'Зробити новий запит',
      'create-request-description': 'Для запиту документа, виберіть тип запитуваного документа, а потім період у полі, що з\'явиться:',
      'choose-doc-type': 'Виберіть тип документу',
      'choose-date': 'Виберіть дату',
      'start-date': 'Початок періоду',
      'end-date': 'Кінець періоду',
      'request': 'Запитати',
      'all-received': 'Усі отримані документи',
      'waiting': 'Чекають на підпис',
      'type-filter': ' Фільтрувати за типом документа',
      'description': 'Документи, надіслані у відповідь на ваш запит, або згенеровані брокером',
      'doc-name': 'Назва документа',
      'doc-type': 'Тип документа',
      'send-date': 'Дата відправки',
      'request-date': 'Дата запиту',
      'request-period': 'За період',
      'status': 'Статус',
      'actions': 'Дії'
    },
    'document-request': {
      'title': ''
    }

  }
}
